import { cn } from '#app/utils/misc.tsx'

export type FaqItem = { q: React.ReactNode; a: React.ReactNode }

type Props = {
	items: FaqItem[]
	className?: string
}

/**
 * FAQ list rendered with native `<details>` — keyboard accessible, zero JS,
 * works without hydration. One item open at a time is NOT enforced; users
 * can open several.
 */
export function FaqList({ items, className }: Props) {
	return (
		<div
			className={cn(
				'border-border divide-border divide-y border-y',
				className,
			)}
		>
			{items.map((item, i) => (
				<details key={i} className="group py-5">
					<summary className="text-foreground hover:text-primary flex cursor-pointer items-center justify-between gap-4 text-base font-semibold tracking-tight md:text-lg">
						<span>{item.q}</span>
						<span
							aria-hidden
							className="text-muted-foreground group-open:rotate-180 inline-block transition-transform"
						>
							▾
						</span>
					</summary>
					<div className="text-foreground/85 mt-3 max-w-2xl text-sm leading-relaxed md:text-base">
						{item.a}
					</div>
				</details>
			))}
		</div>
	)
}
